import axios from 'axios';
import environment from '../environment/environment';

const api = axios.create({ baseURL: environment.API_URL });

export const requestAuth0 = {
  authorizationParams: { audience: 'cms-black-authentication-auth' },
};

export const getUserLocalStorageToken = () => {
  return JSON.parse(localStorage.getItem(
    `@@auth0spajs@@::${environment.AUTH_CLIENT_ID}::cms-black-authentication-auth::openid profile email offline_access`
  ))?.body.access_token;
};


export const logout = () => {
  try {
    // Limpar token do sessionStorage
    sessionStorage.removeItem('structured:api-token');

    // Limpar token do localStorage (Auth0)
    const auth0Key = `@@auth0spajs@@::${environment.AUTH_CLIENT_ID}::cms-black-authentication-auth::openid profile email offline_access`;
    localStorage.removeItem(auth0Key);

    // Limpar outros dados relacionados ao Auth0 (opcional)
    Object.keys(localStorage).forEach(key => {
      if (key.includes('@@auth0spajs@@')) {
        localStorage.removeItem(key);
      }
    });

    // Limpar sessionStorage relacionado (opcional)
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('structured:') || key.includes('auth')) {
        sessionStorage.removeItem(key);
      }
    });

    console.log('Logout realizado com sucesso - tokens removidos');
    return true;
  } catch (error) {
    console.error('Erro ao fazer logout:', error);
    return false;
  }
};


if (api) {
  api.interceptors.request.use(async (req) => {
    try {
      // Try to get Auth0 token if available\

      const token = sessionStorage.getItem('structured:api-token') || getUserLocalStorageToken();

      if (token) {
        req.headers.Authorization = `Bearer ${token}`;
      }
      else {
        console.warn('Auth0 token getter not available');
      }
    } catch (error) {
      console.warn('Failed to get Auth0 token:', error);
    }

    req.headers['Ocp-Apim-Subscription-Key'] = `${environment.SUBSCRIPTION_KEY}`;
    req.headers['Content-Type'] = 'application/json';
    req.headers.Accept = 'application/pdf';

    return req;
  }, error => Promise.reject(new Error(error)));
}

export default api;
